<script setup>
import { onMounted } from 'vue'
import { Link } from '@inertiajs/inertia-vue3'
import stripslashes, { replaceS3path } from '@/Shared/helper.js'
import { brandHasWebsite } from '@/Shared/helper-contents.js'
import ButtonFavoriteToggle from '@/Shared/Buttons/ButtonFavoriteToggle'

const props = defineProps({
  info: Object,
})

onMounted(() => {})
</script>

<template>
  <div class="relative bg-white rounded-[20px] h-full overflow-hidden [&_a]:flex [&_a]:items-center [&_a]:justify-center [&_a]:relative [&_a]:w-full [&_a]:h-full [&_a]:p-[15%] [&_img]:max-h-full">
    <template v-if="brandHasWebsite(info)">
      <a :href="props.info.localWebURL" target="_blank">
        <img :src="replaceS3path(props.info.brandThumb)" :alt="stripslashes(props.info.brandName)" />
      </a>
    </template>
    <template v-else>
      <Link :href="`/brands/${props.info.brandSlug}`">
        <img :src="replaceS3path(props.info.brandThumb)" :alt="stripslashes(props.info.brandName)" />
      </Link>
    </template>
    <ButtonFavoriteToggle category="brand" :disabled="true" :slug="props.info.brandSlug" class="no-outline absolute top-[15px] right-[15px] [&_svg]:w-[13px] [&_svg]:h-[13px]" />
  </div>
</template>
